module.exports = __webpack_public_path__ + "static/media/kit_keyboardPiano_bg.8f346e63.png";